"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var ShimmerGap_base_1 = require("./ShimmerGap.base");
var ShimmerGap_styles_1 = require("./ShimmerGap.styles");
exports.ShimmerGap = Utilities_1.styled(ShimmerGap_base_1.ShimmerGapBase, ShimmerGap_styles_1.getStyles);
//# sourceMappingURL=ShimmerGap.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Shimmer/ShimmerGap/ShimmerGap.js
// module id = 829
// module chunks = 0